/* Corporate Garden Party landing page behavior.
   Handles reveals, accessible FAQs, sticky mobile CTA, and analytics hooks. */
(function () {
  if (window.__cgpLoaded) return;
  window.__cgpLoaded = true;

  function pushEvent(name, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload || {}));
  }

  function init(root) {
    var scope = root || document;
    var page = scope.querySelector('.cgp') || (scope.matches && scope.matches('.cgp') ? scope : null);
    if (!page || page.dataset.cgpInit === '1') return;
    page.dataset.cgpInit = '1';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var reveals = Array.prototype.slice.call(page.querySelectorAll('.cgp__reveal'));

    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('cgp__is-visible'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cgp__is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { revealObserver.observe(el); });
      window.setTimeout(function () {
        reveals.forEach(function (el) { el.classList.add('cgp__is-visible'); });
      }, 1800);
    }

    page.querySelectorAll('[data-cgp-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.cgp__faq-item');
        var answer = item && item.querySelector('.cgp__faq-answer');
        if (!item || !answer) return;
        var isOpen = button.getAttribute('aria-expanded') === 'true';

        page.querySelectorAll('[data-cgp-faq-button][aria-expanded="true"]').forEach(function (openButton) {
          if (openButton === button) return;
          openButton.setAttribute('aria-expanded', 'false');
          var openItem = openButton.closest('.cgp__faq-item');
          var openAnswer = openItem && openItem.querySelector('.cgp__faq-answer');
          if (openAnswer) openAnswer.style.maxHeight = null;
        });

        button.setAttribute('aria-expanded', String(!isOpen));
        answer.style.maxHeight = isOpen ? null : answer.scrollHeight + 'px';
        if (!isOpen) pushEvent('bb_corporate_workshop_faq_open', { question: button.textContent.trim() });
      });
    });

    page.querySelectorAll('[data-cgp-cta]').forEach(function (link) {
      link.addEventListener('click', function () {
        pushEvent('bb_corporate_workshop_cta_click', {
          cta_location: link.getAttribute('data-cgp-cta') || 'unknown',
          cta_text: link.textContent.trim()
        });
      });
    });

    var form = page.querySelector('[data-cgp-form], .cgp__proposal-form');
    if (form) {
      var started = false;
      form.addEventListener('focusin', function () {
        if (started) return;
        started = true;
        pushEvent('bb_corporate_workshop_form_start', { form_name: 'corporate_team_proposal' });
      });
      form.addEventListener('submit', function () {
        pushEvent('bb_corporate_workshop_form_submit', { form_name: 'corporate_team_proposal' });
      });

      var params = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
        var input = form.querySelector('[data-cgp-' + key.replace('_', '-') + ']');
        if (input && params.get(key)) input.value = params.get(key);
      });

      var fbclidInput = form.querySelector('[data-cgp-fbclid]');
      if (fbclidInput && params.get('fbclid')) fbclidInput.value = params.get('fbclid');

      var leadIdInput = form.querySelector('[data-cgp-lead-id]');
      var leadId = '';
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        leadId = window.crypto.randomUUID();
      } else {
        leadId = 'cgp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      }
      if (leadIdInput) leadIdInput.value = leadId;
      /* Shopify keeps the LAST duplicate return_to it receives, so every
         return_to input in the form must carry the lead_id — updating only the
         first one lets any stray duplicate strip the ID from the success URL.
         contact_posted=true is required for form.posted_successfully? to be
         true on the redirected page; without it the success state never renders. */
      var returnTo = '/pages/corporate-workshops?contact_posted=true&bb_lead=corporate_workshop&lead_id=' + encodeURIComponent(leadId) + '#team-proposal';
      Array.prototype.forEach.call(form.querySelectorAll('input[name="return_to"]'), function (returnToInput) {
        returnToInput.value = returnTo;
      });
    }

    var sticky = page.querySelector('[data-cgp-mobile-cta]');
    var conversion = page.querySelector('#team-proposal');
    if (sticky && conversion && 'IntersectionObserver' in window) {
      var conversionVisible = false;
      var updateSticky = function () {
        sticky.classList.toggle('cgp__is-visible', window.scrollY > 520 && !conversionVisible);
      };
      var conversionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          conversionVisible = entry.isIntersecting;
          updateSticky();
        });
      }, { threshold: 0.05 });
      conversionObserver.observe(conversion);

      window.addEventListener('scroll', updateSticky, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var page = event.target.querySelector('.cgp');
    if (page) {
      page.dataset.cgpInit = '';
      init(event.target);
    }
  });
})();
